import urls from '@/navigation/urls'
import SystemEventsTypeDropdown from '@/pages/SystemEvents/components/SystemEventsTypeDropdown'
import GoToLinkButton from '@/shared/Buttons/GoToLinkButton'
import css from './systemEventsFilter.module.css'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'
import useDebounce from '@/shared/hooks/useDebounce'
import useSkipFirstRenderEffect from '@/shared/hooks/useSkipFirstRenderEffect'
import { useState } from 'react'

interface IProps {
  onSelectedEventTypeChange: (statutes: ISystemEvent['type'][], name: string) => void
  selectedEventType: ISystemEvent['type'][]
  name: string
  debounceTimeoutMs?: number
}

const SystemEventsFilter = ({ debounceTimeoutMs = 300, ...props }: IProps) => {
  const [events, setEvents] = useState<ISystemEvent['type'][]>(props.selectedEventType || [])
  const debounced = useDebounce(events, debounceTimeoutMs)

  useSkipFirstRenderEffect(() => {
    props.onSelectedEventTypeChange(events, props.name)
  }, [debounced])

  return (
    <div className={css.filters}>
      <div style={{ width: '152px' }}>
        <SystemEventsTypeDropdown panelStyle={{ left: '0' }} statuses={events} onChange={setEvents} name="type" />
      </div>
      <div className="text-link" style={{ textDecoration: 'none' }}>
        <GoToLinkButton to={urls.systemEvents} text="Открыть в новом окне" />
      </div>
    </div>
  )
}

export default SystemEventsFilter
